if (!customElements.get('card-additional-information')) {
    customElements.define(
        'card-additional-information',
        class CardAdditionalInformation extends HTMLElement {
            constructor() {
                super();
                this.tabRoleClick = '[data-role="tabClick"]';
                this.tabContent = 'card-additional-information__content-item';
            }

            connectedCallback() {
                document.querySelectorAll(this.tabRoleClick).forEach(elem => {
                    elem.addEventListener('click', e => {
                        this.handleClickTitle(e)
                    });
                });
            }
            handleClickTitle(even) {
                if (even.target.classList.contains('active')) return;

                if (even.target.dataset.key) {
                    document.querySelectorAll(this.tabRoleClick).forEach(elem => {
                        elem.classList.remove('active');
                    });
                    Array.prototype.forEach.call(document.getElementsByClassName(this.tabContent), elem => {
                        elem.classList.remove('active');
                    });
                    Array.prototype.forEach.call(document.getElementsByClassName(`card-additional-information-content-${even.target.dataset.key}`), elem => {
                        elem.classList.add('active');
                    });
                    even.target.classList.add('active');
                }
            }
        }
    );
}